import * as localforage from "localforage";
import { createResilientStore } from "./resilient-localforage";

const localforageCommon = createResilientStore(localforage.createInstance({
	driver      : localforage.INDEXEDDB,
	name        : 'Immo',
	version     : 1.0,
	size        : 4980736,
	storeName   : 'omnicasa',
	description : 'Omnicasa Web application'
}), 'omnicasa');

export class LocalforageWrapper{
	static getItem<T>(key: string): Promise<T> {
		return localforageCommon.getItem<T>(key);
	}
	
	static setItem<T>(key: string, value: T): Promise<T> {
		return localforageCommon.setItem<T>(key, value);
	}
	
	static removeItem(key: string): Promise<void> {
		return localforageCommon.removeItem(key);
	}
	
	static clear(): Promise<void> {
		return localforageCommon.clear();
	}
}
